import { Button, ButtonGroup, Modal, Select, TextContainer } from "@shopify/polaris";
import { useCallback, useState } from "react";
import { values } from 'lodash';

const SHIP_VIA_GOGO = 'GoGo Express';
const SHIP_VIA_SHOPEE = 'Shopee checkout';

export default function ConfirmRequest(props) {
  const { open, onClose, onSubmit, selected } = props;
  const [shipVia, setShipVia] = useState();

  let totalQty = 0;
  values(selected).forEach(o => {
    totalQty += Number(o.quantity);
  });

  const handleSelectChange = useCallback((value) => setShipVia(value), []);
  const options = [
    { label: '-- select one --', value: '' },
    { label: SHIP_VIA_SHOPEE, value: SHIP_VIA_SHOPEE },
    { label: SHIP_VIA_GOGO, value: SHIP_VIA_GOGO }
  ];

  function showGogoPrices() {
    if(totalQty<6) {
      return (<div style={{ marginLeft: 15 }}>
        Manila - ₱120<br/>
        Luzon - ₱140<br/>
        Visayas - ₱160<br/>
        Mindanao - ₱180<br/>
      </div>);
    }
    if (totalQty >= 6){
      return (<div style={{ marginLeft: 15 }}>
        Manila - ₱120<br/>
        Luzon - ₱170<br/>
        Visayas - ₱190<br/>
        Mindanao - ₱210<br/>
        </div>);
    }
  }

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        title="Request to ship items separately"
        titleHidden
      >
        <Modal.Section>
          <TextContainer>
            <strong>Request to ship items separately</strong>

            <Select
              label={<b>Ship out via:</b>}
              options={options}
              onChange={handleSelectChange}
              value={shipVia}
            />

            {shipVia && (
              <>
                {shipVia===SHIP_VIA_GOGO && (
                  <>
                    <p>You need to pay this to GoGo Express rider:</p>
                    {showGogoPrices()}
                  </>
                )}
                
                {shipVia===SHIP_VIA_SHOPEE && (
                  <>
                    <p>For paid orders, we will send you a ₱20 Shopee link for you to checkout.</p>
                    <p>For COD, additional 5% transaction fee will be charge to you. For example, ₱480 will be ₱495 on Shopee.</p>
                  </>
                )}

                <p>
                  Take note that the initial shipping fee you paid will be used on the remaining items in your order once they arrived in our store.
                </p>
              </>
            )}

          </TextContainer>

          {shipVia && (
            <div style={{ paddingTop: 10, textAlign: 'right', width: '100%' }}>
              <ButtonGroup fullWidth>
                <Button onClick={onClose}>Cancel</Button>
                <Button primary onClick={() => onSubmit(shipVia)}>I Agree</Button>
              </ButtonGroup>
            </div>
          )}

        </Modal.Section>
      </Modal>
    </div>
  );
}